"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAvailableSilently = exports.isAvailable = exports.getVersion = void 0;

var _requestsGenerator = require("./requests-generator");

/**
 * @deprecated use isAvailableSilently instead
 */
var isAvailable = function isAvailable(states) {
  (0, _requestsGenerator.sendRequests)(function () {
    return states.onSuccess();
  }, states.onError);
};

exports.isAvailable = isAvailable;

var isAvailableSilently = function isAvailableSilently(states) {
  (0, _requestsGenerator.sendRequestsSilently)(states.onSuccess, states.onError);
};
/**
 * @deprecated Found no usage in the codebase, will be removed in the next major release
 */


exports.isAvailableSilently = isAvailableSilently;

var getVersion = function getVersion(states) {
  (0, _requestsGenerator.sendRequests)(function (response) {
    try {
      states.onSuccess(JSON.parse(response !== null && response !== void 0 ? response : '').setappVersion);
    } catch (e) {
      states.onSuccess();
    }
  }, states.onError);
};

exports.getVersion = getVersion;
//# sourceMappingURL=index.js.map